import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import {
  Button as MuiButton, Typography,
  Link as MuiLink, Snackbar as MuiSnackbar,
} from '@mui/material';
import { useDispatch } from '@client/hooks/redux.hooks';
import { startUpdateUserAcceptsCookies } from '@client/slices/helpers/session.reducer';
import { SnackbarAlert } from '@client/components/globals/Snackbar';

const useStyles = makeStyles()((theme) => ({
  cookieContainer: {
    height: 'auto',
    left: theme.spacing(2),
    bottom: theme.spacing(2),
    right: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      bottom: theme.spacing(3),
      maxWidth: 604,
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
    },
  },
}));

export const CookieBannerComponent = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();

  const handleAcceptCookies = useCallback((value) => {
    dispatch(startUpdateUserAcceptsCookies(value));
  }, [dispatch]);

  return (
    <MuiSnackbar
      className={classes.cookieContainer}
      open
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
    >
      <SnackbarAlert
        color="primary"
        action={() => (
          <>
            <MuiButton
              color="primary"
              id="sda-cookie-banner-accept-button"
              onClick={() => handleAcceptCookies(true)}
              variant="contained"
            >
              Accept
            </MuiButton>

            <MuiButton
              variant="outlined"
              color="primary"
              onClick={() => handleAcceptCookies(false)}
            >
              Decline
            </MuiButton>
          </>
        )}
      >
        <Typography variant="body1">
          We use cookies to improve your experience on our site.
          By continuing to use our site you consent to the use of our cookies in accordance with our
          {' '}

          <MuiLink
            id="sda-accepts-cookies-banner-privacy-policy-link"
            variant="body2"
            component={Link}
            to="/privacy-policy"
          >
            Privacy Policy
          </MuiLink>
          .
        </Typography>
      </SnackbarAlert>
    </MuiSnackbar>
  );
};

export default CookieBannerComponent;
